<template>
  <div>
    <div class="todo" ref="carga_test">
      Cargando....
    </div>
    <v-row class="botones_row mt-4">
      <v-col cols="12" class="text-center">
        <a
          href="https://www.worldcobtrustseal.com/bank-transfer/"
          target="_blank"
          rel="noopener noreferrer"
          style="text-decoration: none;"
        >
          <v-btn large class="mt-4 green darken-3  btn_pago"
            ><img :src="image_3" alt="" />
            <div class="ml-2">
              <p class="mb-0">{{ $t("botones_pago[3]") }}</p>
            </div></v-btn
          >
        </a>
      </v-col>

      <v-col cols="12" md="6">
        <h3 class="text-center title_botton mb-2">
          {{ $t("title_pago_free") }}
        </h3>
        <div ref="pago_paypal_free"></div>
      </v-col>
      <v-col cols="12" md="6">
        <h3 class="text-center title_botton mb-2">
          {{ $t("title_pago_year") }}
        </h3>
        <div ref="pago_paypal_year"></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import paises from "../assets/paises.json";
import axios from "axios";
export default {
  data: () => ({
    logo_10: require("../assets/logo_10.svg"),
    image_1: require("../assets/pago_free.png"),
    image_2: require("../assets/pago_anual.png"),
    image_3: require("../assets/logo_11.svg"),
    stripe_js: "",
  }),
  mounted() {
    const script = document.createElement("script");
    script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_KEY_USER}&vault=true&intent=subscription`;
    script.addEventListener("load", this.setLoaded);
    document.body.appendChild(script);
  },
  props: {
    data_form: {
      type: Object,
      default: () => {},
    }
  },
  methods: {
    async setLoaded() {
      var data_test = this.data_form;
      var carga_test = this.$refs.carga_test;
      window.paypal
        .Buttons({
          style: {
            shape: "pill",
            color: "gold",
            layout: "vertical",
            label: "subscribe",
          },
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              plan_id: process.env.VUE_APP_PLAN_PAYPAL_FREE,
            });
          },
          onApprove: async function(respuesta, actions) {            
            carga_test.style.display="flex"
            let language = document.querySelector("html").getAttribute("lang");

            let data = new FormData();

            data.append("correo", data_test.email);
            data.append("empresa", data_test.empresa);
            data.append("nombre", data_test.nombre);
            data.append("telefono", data_test.telefono);
            data.append("pagina", data_test.pagina);
            data.append("pais", data_test.pais);
            data.append("id_pay", respuesta.subscriptionID);
            data.append("tipo", "Membresia mensual");

            let getmail = await axios.post(
              process.env.VUE_APP_URL_SEND_MAIL + "confirm_pay.php",
              data
            );
            if (getmail.data) {
              if (language === "es") {
                window.location.replace(
                  "https://www.worldcobtrustseal.com/es/muchas-gracias-gratis/"
                );
              } else {
                window.location.replace(
                  "https://www.worldcobtrustseal.com/thank-you-transaction/"
                );
              }
            }
          },
          onCancel: function(data) {
            console.log(data);
            carga_test.style.display="none"
          },
          onError: (err) => {
            alert("Ocurrio un error, comuniquisé con el administrador");
            console.error("error from the onError callback", err);
          },
        })
        .render(this.$refs.pago_paypal_free);
      window.paypal
        .Buttons({
          style: {
            shape: "pill",
            color: "gold",
            layout: "vertical",
            label: "subscribe",
          },
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              plan_id: process.env.VUE_APP_PLAN_PAYPAL_YEAR,
            });
          },
          onApprove: async function(respuesta, actions) {          
            carga_test.style.display="flex"

            let language = document.querySelector("html").getAttribute("lang");

            let data = new FormData();

            data.append("correo", data_test.email);
            data.append("empresa", data_test.empresa);
            data.append("nombre", data_test.nombre);
            data.append("telefono", data_test.telefono);
            data.append("pagina", data_test.pagina);
            data.append("pais", data_test.pais);
            data.append("id_pay", respuesta.subscriptionID);
            data.append("tipo", "Membresia Anual");

            let getmail = await axios.post(
              process.env.VUE_APP_URL_SEND_MAIL + "confirm_pay.php",
              data
            );
            if (getmail.data) {
              if (language === "es") {
                window.location.replace(
                  "https://www.worldcobtrustseal.com/es/muchas-gracias/"
                );
              } else {
                window.location.replace(
                  "https://www.worldcobtrustseal.com/thank-you/"
                );
              }
            }
          },
          onCancel: function(data) {
            console.log(data);
            carga_test.style.display="none"
          },
          onError: (err) => {
            console.error("error from the onError callback", err);
            alert("Ocurrio un error, comuniquisé con el administrador");
            console.error("error from the onError callback", err);
          },
        })
        .render(this.$refs.pago_paypal_year);
    },
  },
};
</script>

<style>
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
.botones_row .btn_pago {
  width: 70% !important;
  margin: auto;
}
.botones_row .btn_pago img {
  max-width: 30px;
}
.botones_row .btn_pago p {
  color: white !important;
}
</style>
